export type PlansFaqItemTranslationKeys = {
    id: string;
    titleKey: string;
    contentKey: string;
};

/**
 * プランFAQアイテム（翻訳キー）
 */
export const basicPlanPlansFaqItems: PlansFaqItemTranslationKeys[] = [
    {
        id: 'paymentMethods',
        titleKey: 'faq.items.0.title',
        contentKey: 'faq.items.0.content',
    },
    {
        id: 'applePay',
        titleKey: 'faq.items.1.title',
        contentKey: 'faq.items.1.content',
    },
    {
        id: 'googlePay',
        titleKey: 'faq.items.2.title',
        contentKey: 'faq.items.2.content',
    },
    {
        id: 'cancellation',
        titleKey: 'faq.items.3.title',
        contentKey: 'faq.items.3.content',
    },
    {
        id: 'invoice',
        titleKey: 'faq.items.4.title',
        contentKey: 'faq.items.4.content',
    },
];
